import { render, staticRenderFns } from "./TheReplyDialog.vue?vue&type=template&id=123084b0&scoped=true"
import script from "./TheReplyDialog.vue?vue&type=script&lang=js"
export * from "./TheReplyDialog.vue?vue&type=script&lang=js"
import style0 from "./TheReplyDialog.vue?vue&type=style&index=0&id=123084b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123084b0",
  null
  
)

export default component.exports